/*

Input: sparseBuckets = [] || [-2, 3, 18, -4, 9]
where sequences of zeroes are replaced with the negative of their size

Output: [0, 0, 3, 18, 0, 0, 0, 0, 9]
where index corresponds to the bucket index and the value corresponds to the bucket count at that index

*/

import { HistogramBucket } from 'src/components/charts/helpers/histogram';

export function decodeSparseBuckets(sparseBuckets: ReadonlyArray<number>) {
  const buckets: HistogramBucket[] = [];
  let index = 0;
  sparseBuckets.forEach((num) => {
    if (num < 0) {
      index += num * -1;
    } else {
      buckets.push({ index: index++, count: num });
    }
  });

  return buckets;
}
